enum PickUpDropOffEnum {
  OTHER = 'other',
}

export { PickUpDropOffEnum }
